import { styled } from '@linaria/react';
import { fonts, layout, radius, semantic, size, space } from '../../theme/tokens';
import { visuallyHidden } from '../../utils/visuallyHidden';

export const Shell = styled.div`
  display: flex;
  flex-direction: column;
  --layout-viewport-height: calc(100vh - var(--announcement-banner-height, 0px));
  min-height: 100vh;
  background: ${semantic.bg.canvas};
  --sticky-footer-offset-bottom: ${layout.mobileNavHeight};
  --shell-mobile-nav-height: ${layout.mobileNavHeight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    --sticky-footer-offset-bottom: 0px;
    --shell-mobile-nav-height: 0px;
  }

  &[data-hide-navigation='true'] {
    --sticky-footer-offset-bottom: 0px;
    --shell-mobile-nav-height: 0px;
  }
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
`;

export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: calc(var(--shell-mobile-nav-height, 0px) + var(--page-sticky-bar-height, 0px));
`;

export const Main = styled.main`
  flex: 1;
  min-width: 0;
  overflow-x: clip;

  &:focus {
    outline: none;
  }
`;

export const SkipLink = styled.a`
  ${visuallyHidden}

  &:focus {
    clip: auto;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    top: ${space['space-400']};
    left: ${space['space-400']};
    z-index: ${layout.zIndexModal};
    padding: ${space['space-300']} ${space['space-500']};
    border-radius: ${radius('input', 'radius-md')};
    background: ${semantic.bg.canvas};
    color: ${semantic.text.primary};
    font-family: ${fonts.body};
    font-size: ${fonts.size.sm};
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;
